export const SOLANA_CHAINS = [
    'solana:mainnet',
    'solana:devnet',
    'solana:testnet',
    'solana:localnet'
];
//# sourceMappingURL=constants.js.map